import {
	Component,
	OnInit,
	Input,
	ComponentFactoryResolver,
	ViewContainerRef,
	ComponentRef,
	ViewChild,
	Output,
	EventEmitter,
	HostBinding,
	Optional,
	OnDestroy,
} from "@angular/core";
import { CtaButtonLayoutIconTitleComponent } from "../cta-button--layouts/cta-button-layout-icon-title/cta-button-layout-icon-title.component";
import { CtaButtonLayoutSubtitleNotePriceComponent } from "../cta-button--layouts/cta-button-layout-subtitle-note-price/cta-button-layout-subtitle-note-price.component";
import { CtaButtonLayoutInternetDataComponent } from "../cta-button--layouts/cta-button-layout-internet-data/cta-button-layout-internet-data.component";
import { CTAButtonLayout } from "../cta-button--layouts/cta-button-layout";
import {
	CTAButtonLayoutContext,
	CTAButtonContext,
} from "../cta-button/cta-button.models";
import { CtaButtonMultipleSelectGroupComponent } from "../cta-button-multiple-select-group/cta-button-multiple-select-group.component";
import { BehaviorSubject } from "rxjs";

const components = {
	IconTitleContext: CtaButtonLayoutIconTitleComponent,
	SubtitleNotePriceContext: CtaButtonLayoutSubtitleNotePriceComponent,
	TitleNotePriceContext: CtaButtonLayoutInternetDataComponent,
};

@Component({
    selector: "dodo-cta-button-multiple-select",
    templateUrl: "./cta-button-multiple-select.component.html",
    styleUrls: ["./cta-button-multiple-select.component.scss"],
    standalone: false
})
export class CtaButtonMultipleSelectComponent implements OnInit, OnDestroy {
	@Input() id: string | number;
	@Input() isRadio: boolean;
	@Input() isCheckBox: boolean;

	@Input() layoutContext: CTAButtonLayoutContext;

	@HostBinding("class.active")
	__active: boolean;

	__selected: boolean;

	@Input() set active(val: boolean) {
		console.log("activating button : ", this.id, val);
		this.__active = val;
	}

	@Input() set isSelected(val: boolean) {
		if (val) {
			this._clicked();
		}
	}

	// @Input() set selected(val: boolean) {
	// 	console.log("activating button : ", this.id, val);
	// 	this.__selected = val;
	// 	if (val) {
	// 		this._clicked();
	// 	}
	// }

	@Output() selected = new EventEmitter<string | number>();

	@Output() unSelected = new EventEmitter<string | number>();

	statusUpdated$: BehaviorSubject<boolean>;

	@HostBinding("class.disabled")
	@Input()
	disabled: boolean;

	@Input()
	tags: string[];

	@Input()
	titleBelowButton: string;

	@Input() set context(ctx: CTAButtonContext<CTAButtonLayoutContext>) {
		this.id = this.id || ctx.id;
		this.tags = this.tags || ctx.tags;
		this.layoutContext = this.layoutContext || ctx.layoutContext;

		console.log("tags : ", this.tags);
	}

	@Output() clicked = new EventEmitter<string | number>();

	@ViewChild("componentContainer", { static: true, read: ViewContainerRef })
	componentContainer: ViewContainerRef;

	_component: ComponentRef<CTAButtonLayout>;

	constructor(
		private __resolver: ComponentFactoryResolver,
		@Optional()
		private __ctaButtonGroup: CtaButtonMultipleSelectGroupComponent
	) {
		this.statusUpdated$ = new BehaviorSubject(false);
	}

	ngOnInit() {
		if (this.layoutContext) {
			if (this.layoutContext.type) {
				const componentClass = components[this.layoutContext.type];
				if (componentClass) {
					const factory = this.__resolver.resolveComponentFactory<
						CTAButtonLayout
					>(componentClass);
					this._component = this.componentContainer.createComponent(
						factory
					);
					this._component.instance.layoutContext = this.layoutContext;
				}
			}
		}

		if (this.__ctaButtonGroup) {
			this.__ctaButtonGroup.addButton(this);
		}

		console.log("activating button init before activate: ", this.id);
		if (this.__selected) {
			console.log("activating button init within activate: ", this.id);
			this._clicked();
		}
	}

	ngOnDestroy() {
		if (this.__ctaButtonGroup) {
			this.__ctaButtonGroup.removeButton(this);
		}
	}

	updateActiveStatus(status: boolean) {
		this.__active = status;
		this.statusUpdated$.next(this.__active);
	}

	_clicked() {
		if (this.__active) {
			this.__active = false;
			this.clicked.emit(null);
			this.__ctaButtonGroup.registerInactiveCard(this.id);
		} else {
			this.__active = true;
			this.clicked.emit(this.id);
			this.__ctaButtonGroup.registerActiveCard(this.id);
		}
	}

	makeItActive() {
		this.selected.emit(this.id);
		if (this.__ctaButtonGroup) {
			this.__ctaButtonGroup.registerActiveCard(this.id);
		}
	}

	makeItInactive() {
		this.unSelected.emit(this.id);
		if (this.__ctaButtonGroup) {
			this.__ctaButtonGroup.registerInactiveCard(this.id);
		}
	}
}
